// /js/core/colors.js
"use strict";

export function colorsFilterBar() {
    const bars = document.querySelectorAll('.colors-filter-bar');
    bars.forEach((bar) => {
        if (bar.dataset.colorsBound) return;
        // Placeholder: keep for future behaviors (e.g., scroll/active states)
        bar.dataset.colorsBound = '1';
    });
}
